import { Resource as o, API as e } from "@coveo/platform-client";
const t = class t extends o {
  /**
   * Returns a paginated list of insight panel configurations for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve insight panel configurations.
   * @param {InsightPanelConfigListOptions} options Options to configure the request.
   * @returns {Promise<PageModel<InsightPanelConfigModel>>} Paginated list of insight panel configurations for the specified project.
   */
  listInsightPanelConfigsByProjectId(s, r = {}) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/projects/configs`, {
        ...r,
        projectId: s
      })
    );
  }
};
t.baseUrl = `/rest/organizations/${e.orgPlaceholder}/insightconfig/v1`;
let i = t;
export {
  i as InsightPanelConfigsInternalResource
};
//# sourceMappingURL=InsightPanelConfigsInternalResource.js.map
